module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyrightt"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("A F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EIWEL AND")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIENDS")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK")]), _c('br'), _vm._v("An Imprint of Macmillan")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EYES ON THE GOAL")]), _vm._v(". Copyright © 2010 by John Coy."), _c('br'), _vm._v("All rights reserved. Distributed in Canada by H.B. Fenn and Company, Ltd."), _c('br'), _vm._v("Printed in March 2010 in the United States of America"), _c('br'), _vm._v("by R. R. Donnelley & Sons Company, Harrisonburg, Pennsylvania."), _c('br'), _vm._v("For information, address Feiwel and Friends, 175 Fifth Avenue,"), _c('br'), _vm._v("New York, N.Y. 10010.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Coy, John,"), _c('br'), _vm._v("Eyes on the goal / John Coy. — 1st ed."), _c('br'), _vm._v("p. cm."), _c('br'), _vm._v("Summary: Middle-schooler Jackson’s baseball skills are not of much help"), _c('br'), _vm._v("when he and his friends go to soccer camp, and while there he learns that his"), _c('br'), _vm._v("mother’s boyfriend has invited them to move into his house, and friend"), _c('br'), _vm._v("Gig’s father is deployed to Afghanistan."), _c('br'), _vm._v("ISBN: 978-0-312-37330-6"), _c('br'), _vm._v("[1. Soccer—Fiction. 2. Camps—Fiction. 3. Ability—Fiction."), _c('br'), _vm._v("4. Friendship—Fiction. 5. Soldiers—Fiction. 6. Family life—Fiction.]"), _c('br'), _vm._v("I. Title."), _c('br'), _vm._v("PZ7.C839455Eye 2010"), _c('br'), _vm._v("[Fic]—dc22"), _c('br'), _vm._v("2009045387")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Book design by Tim Hall")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Feiwel and Friends logo designed by Filomena Tuosto")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First Edition: 2010")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("10  9  8  7  6  5  4  3  2  1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.feiwelandfriends.com",
      "target": "_blank"
    }
  }, [_vm._v("www.feiwelandfriends.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49af5c96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 63
// module chunks = 0